import type { Cart } from 'types/cart/Cart';
import type { CartLineItem } from 'types/cart/CartLineItem';

export const getCartItemBySelectedItem = ({
  cart,
  variantId,
  subscriptionId,
}: {
  cart?: Cart | null;
  variantId: string;
  subscriptionId?: string;
}): CartLineItem | null | undefined => {
  if (!cart) {
    return null;
  }

  cart.lines.find((item) => {
    if (subscriptionId) {
      return (
        item.merchandise.id === variantId &&
        item?.sellingPlanAllocation?.sellingPlan.id === subscriptionId
      );
    }

    return item.merchandise.id === variantId;
  });
};
